import { Icon } from '@chakra-ui/react';

export default function SFInfoIcon(props) {
  return (
    <Icon
      width={4}
      height={17}
      viewBox='0 0 16 17'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M8 16.3281C3.64844 16.3281 0.03125 12.7109 0.03125 8.35938C0.03125 4 3.64062 0.390625 7.99219 0.390625C12.3516 0.390625 15.9688 4 15.9688 8.35938C15.9688 12.7109 12.3594 16.3281 8 16.3281ZM8 15C11.6875 15 14.6406 12.0469 14.6406 8.35938C14.6406 4.67188 11.6797 1.71875 7.99219 1.71875C4.30469 1.71875 1.36719 4.67188 1.36719 8.35938C1.36719 12.0469 4.3125 15 8 15ZM7.92969 5.65625C7.36719 5.65625 6.91406 5.20312 6.91406 4.63281C6.91406 4.0625 7.36719 3.60938 7.92969 3.60938C8.5 3.60938 8.94531 4.0625 8.94531 4.63281C8.94531 5.20312 8.5 5.65625 7.92969 5.65625ZM6.63281 12.7344C6.3125 12.7344 6.0625 12.5 6.0625 12.1797C6.0625 11.875 6.3125 11.6328 6.63281 11.6328H7.60156V8.05469H6.76562C6.44531 8.05469 6.19531 7.82031 6.19531 7.5C6.19531 7.19531 6.44531 6.95312 6.76562 6.95312H8.23438C8.63281 6.95312 8.84375 7.23438 8.84375 7.65625V11.6328H9.8125C10.1328 11.6328 10.3828 11.875 10.3828 12.1797C10.3828 12.5 10.1328 12.7344 9.8125 12.7344H6.63281Z' />
    </Icon>
  );
}
